import React, { useState } from 'react';
import { addRace } from '../../api';

export default function AdminAddRace({ onCreated, setMessage }) {
    const [name, setName] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');

    async function handleAdd() {
        if (!name || !date || !time) return setMessage && setMessage('Provide name, date and start time');
        try {
            const row = await addRace(name.trim(), date, time);
            setName(''); setDate(''); setTime('');
            if (onCreated) onCreated(row);
            if (setMessage) setMessage(`Added race ${row.name || row.race_name}`);
        } catch (err) {
            console.error('AdminAddRace error', err);
            setMessage && setMessage('Unable to add race');
        }
    }

    return (
        <div>
            <h5 className="mb-3">Add New Race</h5>
            <div className="card mb-3">
                <div className="card-body">
                    <div className="row g-2 align-items-end">
                        <div className="col-auto">
                            <label className="form-label">Grand Prix name</label>
                            <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g., British Grand Prix" />
                        </div>
                        <div className="col-auto">
                            <label className="form-label">Date</label>
                            <input type="date" className="form-control" value={date} onChange={(e) => setDate(e.target.value)} />
                        </div>
                        <div className="col-auto">
                            <label className="form-label">Start time (local)</label>
                            <input type="time" className="form-control" value={time} onChange={(e) => setTime(e.target.value)} />
                        </div>
                        <div className="col-auto">
                            <button className="btn btn-primary" type="button" onClick={handleAdd}>Add Race</button>
                        </div>
                    </div>
                    <div className="small text-muted mt-2">Enter date and local start time; it will be converted to the DB UTC format.</div>
                </div>
            </div>
        </div>
    );
}
